import { useState } from "react";
import { ExperimentOutlined } from "@ant-design/icons";
import { Button, type ButtonProps } from "antd";

import { useSimulatorAccess } from "./simulatorAccess";
import TraineeSimulatorModal from "./TraineeSimulatorModal";

type Props = {
  traineeId: string;
  size?: ButtonProps["size"];
  type?: ButtonProps["type"];
  label?: string;
};

/**
 * Jedyne wejście do symulatora — sam pilnuje bramek (staging + flaga + właściciel konta),
 * więc miejsca użycia nie muszą tego powtarzać. Poza stagingiem nie renderuje niczego.
 */
const TraineeSimulatorButton = ({ traineeId, size = "small", type = "default", label }: Props) => {
  const { canUseSimulator } = useSimulatorAccess();
  const [open, setOpen] = useState(false);

  if (!canUseSimulator) {
    return null;
  }

  return (
    <>
      <Button size={size} type={type} icon={<ExperimentOutlined />} onClick={() => setOpen(true)}>
        {label ?? "Symulator"}
      </Button>
      <TraineeSimulatorModal traineeId={traineeId} open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default TraineeSimulatorButton;
